import classNames from 'classnames';
import { Conditional } from '@consumidor-positivo/aurora';
import { NewCard, OfferSkeleton } from '@libs/creditkit';
import { useDogxContext } from '@libs/dogx';
import { useUser } from '@common/hooks/useUser';

import { MainOfferCard } from '../MainOfferCard';
import { FeaturedOfferTemplate as Template } from './Template';
import { FeaturedOffersCarousel as Carousel } from './components/Carousel';
import { OfferFeaturedProps } from './types';
import { useGetOffers } from '@hub/hooks/useGetOffers';

import './styles.scss';

export const OfferFeatured = ({ location, forceDecide, onClickOffersCTA, blockTitle, withIlustration }: OfferFeaturedProps) => {
  const { redirectToOffers, SHLoading, noOffer, decideDone, featuredOffers } = useGetOffers({ callSHDecide: forceDecide });

  //#region AB Test - dx-new-offer-card-carousel
  const { getExperimentVariant } = useDogxContext();
  const isNewCard = (getExperimentVariant('dx-new-offer-card-carousel') ?? 'control') === 'new-card';
  const user = useUser();
  //#endregion

  const title = blockTitle ? blockTitle : 'Você tem ofertas liberadas te esperando';

  return (
    <Template
      title={title}
      noOffer={noOffer}
      withIlustration={withIlustration}
      onClickMoreOffersBtn={() => {
        redirectToOffers();
        onClickOffersCTA && onClickOffersCTA();
      }}
    >
      <Conditional
        condition={SHLoading || !decideDone}
        renderIf={
          <div className="offer-featured__skeleton">
            <OfferSkeleton />
          </div>
        }
        renderElse={
          <Carousel>
            {featuredOffers?.slice(0, 2).map((offer, index) => (
              <div className={classNames('offer-featured__card-container', { 'offer-featured__card-container--new-card': isNewCard })} key={`offer-filtered-card__${offer?.content?.slug}-${index}`}>
                {isNewCard
                  ? <NewCard offer={offer} index={index} location={location} user={user} />
                  : <MainOfferCard index={index} location={location} offer={offer} />}
              </div>
            ))}
          </Carousel>
        }
      />
    </Template>
  );
};
